var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-bid"},[_c('AddBidDropdown',{on:{"command":_vm.switchModals}}),_vm._v(" "),_c('AddBidModal',{model:{value:(_vm.showSingleAddBidModal),callback:function ($$v) {_vm.showSingleAddBidModal=$$v},expression:"showSingleAddBidModal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }